import { Table } from '@tanstack/react-table'

import { MultiSelectCombobox, SelectOption } from '@/components/form-components/MultiSelectCombobox'

import { ExistingRegisteredTool } from './platformAgentToolsTableUtils'

type PlatformAgentToolsFiltersProps = {
  table: Table<ExistingRegisteredTool>
  moduleOptions: SelectOption<string>[]
}

export function PlatformAgentToolsFilters({ table, moduleOptions }: PlatformAgentToolsFiltersProps) {
  const selectedModules = ((table.getColumn('moduleName')?.getFilterValue() as string[] | undefined) ?? []).filter(
    Boolean
  )

  return (
    <div className="w-56">
      <MultiSelectCombobox
        triggerClassName="h-9"
        renderBadgesInTrigger
        options={moduleOptions}
        selectedValues={selectedModules}
        onSelectionChange={(values) =>
          table.getColumn('moduleName')?.setFilterValue(values.length > 0 ? values : undefined)
        }
        placeholder="By Module"
        searchPlaceholder="Search modules..."
        emptyMessage="No modules found."
      />
    </div>
  )
}
